import { initLiveList } from '../../shared/liveList.js';

// The log of the hourly Zefix sweeps (N14).
//
// Nothing but the live list: a sweep that already happened has no decision left
// to make, and the page offers no action - unlike the fetch log, which has a
// button to start a run. So there is no polling either; the sweep is written to
// the log only once it is over, so a row on the page is always a finished run.

export function initZefixLaeufe() {
  initLiveList({
    results: 'zefix-lauf-list',
    path: '/zefix/laeufe',
    forms: ['zefix-lauf-filter']
  });
}
